import { getISODate, isAfter, isBetween, isBefore } from '../util/date';

class OrderWindow {
  constructor(item) {
    const {
      orderWindowStartDate,
      orderWindowStartTime,
      orderWindowEndDate,
      orderWindowEndTime,
      seasonName,
      catalogClosureNote,
      deadlineDetails
    } = item;

    // TODO: These date/times from the service should be in an RFC2822 or ISO format
    this.begin = getISODate(orderWindowStartDate, orderWindowStartTime).dateTime;
    this.closureNote = catalogClosureNote;
    this.end = getISODate(orderWindowEndDate, orderWindowEndTime).dateTime;
    this.name = seasonName;
    this.details = deadlineDetails;
  }

  isExpired() {
    return isAfter({ start: this.end, date: new Date().toISOString() });
  }

  currentlyActive() {
    return isBetween({ start: this.begin, end: this.end, date: new Date().toISOString() });
  }

  isUpcoming() {
    return isBefore({ end: this.begin, date: new Date().toISOString() });
  }
}

export default OrderWindow;
